module.exports = {
      id: "myvikatanbadge-usage",
      viewBox: "0 0 499.854 524.656",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#myvikatanbadge",
      toString: function () {
        return this.url;
      }
    }